import { render, staticRenderFns } from "./TransferDetail.html?vue&type=template&id=f758314c&scoped=true&"
import script from "./TransferDetail.js?vue&type=script&lang=js&"
export * from "./TransferDetail.js?vue&type=script&lang=js&"
import style0 from "./TransferDetail.scss?vue&type=style&index=0&id=f758314c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f758314c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
